<template>
     <div class="profile_area">
        <div class="user_act_count">
            <div class="act_block">
                <div class="count">{{addComma(userInfo.point)}}</div>
                <div class="act_name">포인트</div>
            </div>
            <div class="act_block">
                <div class="count">{{addComma(userInfo.cnt_post)}}</div>
                <div class="act_name">게시글</div>
            </div>
            <div class="act_block">
                <div class="count">{{addComma(userInfo.cnt_comment)}}</div>
                <div class="act_name">댓글</div>
            </div>
            <div class="act_block">
                <div class="count">{{addComma(userInfo.cnt_friend)}}</div>
                <div class="act_name">친구</div>
            </div>
        </div>
        <div class="user_info" v-if="password.val">
            <div class="email">
                {{userInfo.uid}}
            </div>
            <div class="pblock">
                <h3 class="profile_title">닉네임</h3>
                <!-- <img :src="`${require('@/assets/imgs/level/'+userInfo.level+'.png')}`"> -->
                <!-- <input type="text" name="nic" :value="`${userInfo.nic}`" class="input" v-model="user_nic"> -->
                <input type="text" name="nic"  class="input disable" v-model="user_nic.val" readonly @click="changeNic($event)">
            </div>
            <div class="pblock">
                <h3 class="profile_title">비밀번호</h3>
                <!-- <input type="password" name="password" :value="`${password[0]}`" class="input" v-model="password"> -->
                <input type="password" name="password" class="input" v-model="password.val">                 
            </div>
            <div class="pblock">
                <h3 class="profile_title">비밀번호 확인</h3>
                <!-- <input type="password" name="password" :value="`${password[0]}`" class="input" v-model="password"> -->
                <input type="password" name="password_confirmation" class="input" v-model="password_confirmation.val">                
            </div>
            <div class="pblock">
                <h3 class="profile_title">추천인</h3>
                <!-- <img :src="`${require('@/assets/imgs/level/'+userInfo.level+'.png')}`"> -->
                <!-- <input type="text" name="nic" :value="`${userInfo.nic}`" class="input" v-model="user_nic"> -->
                <input type="text" name="recommender"  class="input" 
                :class="{'disable':recommender.isModify === false}" 
                v-model="recommender.val"  
                :readonly="recommender.isModify === false">
            </div>
            <div class="pblock">
                <h3 class="profile_title">프로필 이미지 변경</h3>    
                <div class="preview_wrap">
                    <label for="profile_img">
                        <div id="preview">
                            <img v-if="url" :src="url" width="90" height="90"/>
                            <p v-else>클릭해서<br> 이미지불러오기</p>
                        </div>
                    </label>
                </div>
                <input type="file" id="profile_img" @change="onFileChange" accept='image/jpeg,image/gif,image/png' style="display:none"/>
            </div>
            <div class="edit_profile">
                <base-button-sm mode="orange" @click="editInfo">정보수정</base-button-sm>
            </div>

        </div>
    </div>
</template>
<script>
import { myProfile } from '@/components/mixins/pages/myProfile.js'
export default {
    data(){
        return{
           
        }
    },
    mixins:[ myProfile ],    
    
}
</script>
<style lang="scss" scoped>
.profile_area{
    margin-bottom:30px;
    .user_act_count{
        display: flex;
        justify-content: center;
        .act_block{
            text-align: center;
            margin:0 40px;
            .count{
                font-size:24px;
                font-weight: bold;
                color:#525f7f;
            }
            .act_name{
                margin-top:10px;
                font-size:20px;
                color:#666;
            }
        }
    }
    .user_info{
        text-align:center;
        margin-top:20px;
        .email{
            font-size:24px;
            color:#32325d
        }
        .pblock{
            margin-top:10px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction:column;
            color:#666;
            .disable{
                background:#ccc;
            }
            .preview_wrap{
                margin-bottom:20px;
                text-align:center;
                display:flex;
                justify-content: center;
                #preview{
                    border:5px solid #ccc;
                    width:100px;
                    height:100px;
                    border-radius:10px;
                    cursor:pointer;
                    p{
                        padding-top:20px;
                        color:#ccc;
                    }
                }
            }
        }
        .profile_title{
            text-align:left;
            width:250px;
            font-size:11px;
            color:#666;
        }
       
        .edit_profile{
            margin-top:50px;
            line-height:30px;
            button{width:20%;}
        }
        .input{
            font-size:20px;
            border:none;
            border-bottom:1px dotted #666;
            text-align:center;
        }
    }
}
</style>
